exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".klarna--38W2H{color:#3c84b7;font-size:12px;font-weight:700;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);

// Exports
exports.locals = {
	"klarna": "klarna--38W2H"
};